import React from 'react'
import SliderAbout3Sec1 from './SliderAbout3Sec1/SliderAbout3Sec1'
import SliderAbout3Sec2 from './SliderAbout3Sec2/SliderAbout3Sec2'

function SliderAbout3() {
  return (
    <>
      <SliderAbout3Sec1 />
      <SliderAbout3Sec2 />
    </>
  )
}

export default SliderAbout3
